import getters from './getters'

 const api = {
    namespaced: true,
    strict: process.env.NODE_ENV !== 'production',
    state: {
      defaultCoordinates: {
        latitude: 47,
        longitude: 67
      },
    },
    getters
  }

  export default api